import React, {useState, useEffect} from "react";
import { Eye, EyeOff, User, Lock, Mail, Phone, MapPin, CreditCard, UserPlus, Home } from "lucide-react";
import {WebLink, SiteWide, Images} from "./customComponents";

import {useNavigate, useLocation} from 'react-router-dom';

import APIRequests from '../utility/APIRequests';
import {staticCountries} from '../utility/countries';
import { setUserSession, setUserFinance, setUserToken } from '../utility/CommonAuth';
import Helper1, {notify} from '../utility/Helper1';
import {Alert} from "../alertServices";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {authActions} from '../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect } from '../redux/selectors/index';

const bacggroundImage = require('../images/home-2.jpg');

// Helper to validate referral-like values
const isValidReferral = (val) => !!val && val !== 'null' && val !== 'undefined';

function Signup() {


    const [username, setUsername]                             = useState('');
    const [email, setEmail]                             = useState('');
    const [withdrawalPin, setWithdrawalPin]             = useState('');
    const [showPin, setShowPin]                         = useState(false);
    


    const [password, setPassword]                       = useState('');
    const [loading, changeLoading]                      = useState(false);
    const [fullPageLoading, setFullPageLoading]         = useState(false);
    const [flashCounter, setFlashCounter]               = useState(0);
    const [showPassword, setShowPassword]               = useState(false);
    const [country, setCountry]             = useState(0); //'156'
    const [phone, setPhone]                 = useState('');
    const [phoneCode, setPhoneCode]           = useState('...'); //'+234'
    const [referral, setReferrals]           = useState(() => {
        try{
            const current = typeof localStorage !== 'undefined' ? localStorage.getItem('ref') : '';
            return isValidReferral(current) ? current : '';
        }catch(e){
            return '';
        }
    }); //'+234'
    const [agree, setAgree] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [focusedField, setFocusedField] = useState(null);

    const [walletAddress, setWalletAddress]             = useState('');
    const [bank, setBankName]                           = useState('');
    const [accountName, setAccountName]                 = useState('');
    const [accountNumber, setAccountNumber]             = useState('');
    const [depositMethod, setDepositMethod]             = useState(100);



    const site_settings = useSelector(allRemoteSettingsSelect);
    const search = useLocation().search;
    const referalLink = new URLSearchParams(search).get("ref");

    const navigate                                       = useNavigate();
    const dispatch = useDispatch();

    const paymentMethod = [
        {
            label: 'Bank',
            tag: 0
        },
        {
            label: 'USDTTRC20',
            tag: 1
        },
    ]

    useEffect(() => {
        // Always read the latest stored value to avoid stale module-level cache
        const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('ref') : '';

        if (isValidReferral(referalLink)) {
            localStorage.setItem('ref', referalLink);
            setReferrals(referalLink);
        } else if (isValidReferral(stored)) {
            setReferrals(stored);
        } else {
            setReferrals('');
        }
    }, [referalLink])


    const checkboxHandler = () => {
        // if agree === true, it will be set to false
        // if agree === false, it will be set to true
        setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const handleInputFocus = (field) => {
        setFocusedField(field);
    };

    const handleInputBlur = () => {
        setFocusedField(null);
    };


    const doRegister = async (e) => {
        if(!agree){
            notify('You must accept the terms and condition to continue', 0);
            return;
        }
        
        e.preventDefault();
        changeLoading(true);
        setFullPageLoading(true);
        let financeLoad;

        let payLoad = {depositMethod, username, email, password, country, phone, withdrawalPin, referral}
        if(depositMethod == 0){
            financeLoad = {bank, accountName, accountNumber}
        }else{
            financeLoad = {walletAddress}
        }

        dispatch(authActions.onSignUp("account/register", Object.assign({}, payLoad, financeLoad), response => {

            if(response.code != 0){

                localStorage.removeItem('ref');
                
                // if(response.code == 1){
                    navigate('/personal-information');
                // }else if(response.code == 2){
                //     navigate('/personal-information');
                // }
                
            }else{
                notify(response.msg, response.code)
            }

            changeLoading(false);
            setFullPageLoading(false);
        
        }),
        );
    }


  const changeCountry = (countryId) =>{
    let selectedCountry = staticCountries.filter(e => e.id == countryId) 
    setCountry(countryId);
    let countryPhoneCode = selectedCountry?.[0]?.phonecode;
    setPhoneCode(countryPhoneCode);
    
  }


    const bg = require('../images/auth.jpg');


    return (
        <SiteWide>
            <div style={{backgroundColor: `#233950`}} className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden bg-dark">
                {/* Animated background elements */}
                <div className="absolute inset-0 opacity-20">
                    <div className="absolute top-20 left-20 w-72 h-72 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
                    <div className="absolute top-40 right-20 w-72 h-72 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
                    <div className="absolute -bottom-8 left-40 w-72 h-72 bg-gradient-to-r from-green-500 to-cyan-500 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-500"></div>
                </div>

                {/* Floating particles */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-2 h-2 bg-white rounded-full opacity-20 animate-bounce"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 2}s`,
                                animationDuration: `${2 + Math.random() * 2}s`
                            }}
                        ></div>
                    ))}
                </div>

                {/* Main signup container */}
                <div className="relative z-10 w-full max-w-md">
                    {/* Glowing border effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 rounded-2xl blur-sm opacity-75 animate-pulse"></div>

                    <div className="relative bg-gray-900/80 backdrop-blur-xl rounded-2xl p-8 shadow-2xl border border-gray-700/50">
                        {/* Header */}
                        <div className="text-center mb-8">
                            <div className="relative inline-block">
                                <Images
                                    height="60px"
                                    src={site_settings?.site_settings?.logo || "/api/placeholder/200/60"}
                                    alt="logo"
                                    className="mx-auto mb-4 filter brightness-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-purple-500 rounded-lg blur-lg opacity-30"></div>
                            </div>
                            <h2 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent mb-2">
                                Create Account
                            </h2>
                            <p className="text-gray-400 text-sm">Join us today</p>
                        </div>

                        <form className="space-y-6">
                            {/* Username field */}
                            <div className="relative group">
                                <label className="block text-sm font-medium text-gray-300 mb-2">
                                    Username
                                </label>
                                <div className="relative">
                                    <div className={`absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'username' ? 'opacity-100' : 'opacity-0'}`}></div>
                                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                    <input
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        onFocus={() => handleInputFocus('username')}
                                        onBlur={handleInputBlur}
                                        placeholder="Enter your username"
                                        className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Email field */}
                            <div className="relative group">
                                <label className="block text-sm font-medium text-gray-300 mb-2">
                                    Email
                                </label>
                                <div className="relative">
                                    <div className={`absolute inset-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'email' ? 'opacity-100' : 'opacity-0'}`}></div>
                                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onFocus={() => handleInputFocus('email')}
                                        onBlur={handleInputBlur}
                                        placeholder="Enter your email"
                                        className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Password field */}
                            <div className="relative group">
                                <label className="block text-sm font-medium text-gray-300 mb-2">
                                    Password
                                </label>
                                <div className="relative">
                                    <div className={`absolute inset-0 bg-gradient-to-r from-green-500/20 to-cyan-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'password' ? 'opacity-100' : 'opacity-0'}`}></div>
                                    <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onFocus={() => handleInputFocus('password')}
                                        onBlur={handleInputBlur}
                                        placeholder="Enter your password"
                                        className="relative w-full pl-12 pr-12 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white transition-colors z-10"
                                    >
                                        {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                            </div>

                            {/* Account Pin field */}
                            <div className="relative group">
                                <label className="block text-sm font-medium text-gray-300 mb-2">
                                    Account Pin (4 digits)
                                </label>
                                <div className="relative">
                                    <div className={`absolute inset-0 bg-gradient-to-r from-pink-500/20 to-purple-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'pin' ? 'opacity-100' : 'opacity-0'}`}></div>
                                    <CreditCard className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                    <input
                                        type={showPin ? "text" : "password"}
                                        value={withdrawalPin}
                                        onChange={(e) => setWithdrawalPin(e.target.value)}
                                        onFocus={() => handleInputFocus('pin')}
                                        onBlur={handleInputBlur}
                                        placeholder="Enter 4-digit pin"
                                        maxLength={4}
                                        className="relative w-full pl-12 pr-12 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPin(!showPin)}
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-white transition-colors z-10"
                                    >
                                        {showPin ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                                    </button>
                                </div>
                            </div>

                            {/* Country field */}
                            <div className="relative group">
                                <label className="block text-sm font-medium text-gray-300 mb-2">
                                    Country
                                </label>
                                <div className="relative">
                                    <div className={`absolute inset-0 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'country' ? 'opacity-100' : 'opacity-0'}`}></div>
                                    <MapPin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                    <select
                                        value={country}
                                        onChange={(e) => changeCountry(e.target.value)}
                                        onFocus={() => handleInputFocus('country')}
                                        onBlur={handleInputBlur}
                                        className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white transition-all duration-300 backdrop-blur-sm appearance-none"
                                        required
                                    >
                                        <option value="" className="bg-gray-800">Select country</option>
                                        {staticCountries.map((item, index) => (
                                            <option key={index} value={item.id} className="bg-gray-800">
                                                {item.nicename}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Phone field */}
                            <div className="relative group">
                                <label className="block text-sm font-medium text-gray-300 mb-2">
                                    Phone
                                </label>
                                <div className="relative">
                                    <div className={`absolute inset-0 bg-gradient-to-r from-orange-500/20 to-red-500/20 rounded-lg transition-opacity duration-300 ${focusedField === 'phone' ? 'opacity-100' : 'opacity-0'}`}></div>
                                    <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
                                    <input
                                        type="text"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        onFocus={() => handleInputFocus('phone')}
                                        onBlur={handleInputBlur}
                                        placeholder="Enter your phone number"
                                        className="relative w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-600 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-white placeholder-gray-400 transition-all duration-300 backdrop-blur-sm"
                                        required
                                    />
                                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm z-10">
                                        {phoneCode}
                                    </div>
                                </div>
                            </div>

                            {/* Terms and conditions */}
                            {(site_settings?.site_settings?.term ?? '') != '' && (
                                <div className="flex items-center space-x-3">
                                    <input
                                        type="checkbox"
                                        id="agree"
                                        checked={agree}
                                        onChange={checkboxHandler}
                                        className="w-4 h-4 text-cyan-500 bg-gray-800 border-gray-600 rounded focus:ring-cyan-500 focus:ring-2"
                                    />
                                    <label htmlFor="agree" className="text-sm text-gray-300">
                                        I agree to{' '}
                                        <WebLink
                                            to="/term"
                                            className="text-cyan-400 hover:text-cyan-300 underline"
                                        >
                                            terms and conditions
                                        </WebLink>
                                    </label>
                                </div>
                            )}

                            {/* Signup button */}
                            <button
                                type="button"
                                disabled={loading || !agree}
                                onClick={doRegister}
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                className="relative w-full py-3 px-6 rounded-lg font-semibold text-white transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 disabled:opacity-50 disabled:cursor-not-allowed overflow-hidden group"
                            >
                                {/* Button background gradient */}
                                <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 transition-opacity duration-300"></div>
                                <div className={`absolute inset-0 bg-gradient-to-r from-cyan-400 via-purple-400 to-pink-400 transition-opacity duration-300 ${isHovered ? 'opacity-100' : 'opacity-0'}`}></div>

                                {/* Button glow effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 blur-lg opacity-50 group-hover:opacity-75 transition-opacity duration-300"></div>

                                <div className="relative flex items-center justify-center space-x-2">
                                    {loading ? (
                                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                    ) : (
                                        <>
                                            <UserPlus className="w-5 h-5" />
                                            <span>Create Account</span>
                                        </>
                                    )}
                                </div>
                            </button>

                            {/* Links */}
                            <div className="flex justify-center items-center text-sm pt-4">
                                <WebLink
                                    to="/signin"
                                    className="text-cyan-400 hover:text-cyan-300 transition-colors duration-200 hover:underline"
                                >
                                    Already have an account? Sign in
                                </WebLink>
                            </div>
                        </form>

                        {/* Decorative elements */}
                        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 rounded-t-2xl"></div>
                    </div>
                </div>

                {/* Bottom navigation icons */}
                <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-20">
                    <div className="flex space-x-6 bg-gray-900/70 backdrop-blur-lg px-6 py-3 rounded-full border border-gray-700/50">
                        {[
                            { icon: Home, to: '/', color: 'text-cyan-400' },
                        ].map(({ icon: Icon, color, to }, index) => (
                            <button
                                onClick={() => navigate(to)}
                                key={index}
                                className={`${color} hover:scale-110 transition-transform duration-200 p-2 rounded-full hover:bg-white/10`}
                            >
                                <Icon className="w-5 h-5" />
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </SiteWide>
    );

}

export default Signup;